<script setup lang="ts">
import { type NavigationItem } from './types';
import { ChevronRightIcon, ArrowLeftIcon } from '@heroicons/vue/outline';

defineProps<{
  item: NavigationItem;
}>();

const showSubMenu = ref(false);
</script>

<template>
  <li
    @click="showSubMenu = true"
    class="flex flex-row items-center justify-between border-b-1 border-gainsboro px-5 py-4 font-medium last-of-type:border-b-0"
  >
    {{ item.title }}
    <ChevronRightIcon class="size-4 stroke-3" />
    <div
      class="absolute top-0 z-40 flex h-svh w-full flex-col bg-white"
      :class="['left-0 top-0 transform transition-transform', showSubMenu ? 'translate-x-0' : '-translate-x-full']"
    >
      <div
        class="flex h-[60px] w-full flex-none items-center border-b-1 border-gainsboro bg-gunmetal px-5 font-heading uppercase tracking-heading text-white last-of-type:border-b-0"
      >
        <button class="flex flex-row items-center gap-3 uppercase" @click.stop="showSubMenu = false">
          <span><ArrowLeftIcon class="size-4 stroke-2" /></span>
          {{ item.title }}
        </button>
      </div>
      <ul class="flex flex-1 flex-col overflow-y-auto bg-white capitalize">
        <nuxt-link
          v-if="item.link"
          class="flex flex-row items-center justify-between bg-anti-flash-white px-5 py-4 font-medium last-of-type:border-b-0"
          :to="item.link.href"
          >{{ item.link.title }} <ChevronRightIcon class="size-4 stroke-3"
        /></nuxt-link>
        <template v-for="subItem in item.items">
          <nuxt-link
            class="flex flex-row items-center justify-between border-b-1 border-gainsboro px-5 py-4 last-of-type:border-b-0"
            v-if="subItem.href"
            :to="subItem.href"
            >{{ subItem.title }} <ChevronRightIcon class="size-4 stroke-3"
          /></nuxt-link>
          <MobileNavigationSubMenu v-else :item="subItem" />
        </template>
      </ul>
    </div>
  </li>
</template>
